import { History } from "lucide-react";
import VideoSection from "@/components/product/VideoSection";

const TimelineSection = () => {
  return (
    <section className="section-padding bg-drcash-sapphire-blue">
      <div className="container mx-auto px-4 md:px-8">
        <div className="flex items-center gap-4 mb-0 my-10 justify-center pb-0">
          <History className="w-8 h-8 text-drcash-caribbean-green" />
          <h2 className="text-3xl md:text-4xl font-bold text-white">
            Conheça a nossa história do negócio
          </h2>
        </div>

        <div className="mb-16">
          <VideoSection title="" videoEmbedId="7Lk9kaE23xc" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div className="max-w-3xl space-y-12">
            <div className="relative pl-8 border-l-2 border-drcash-caribbean-green">
              <div className="absolute w-4 h-4 bg-drcash-caribbean-green rounded-full -left-[9px] top-0"></div>
              <span className="text-drcash-caribbean-green text-2xl font-bold mb-2 block">2018</span>
              <p className="text-white">
                Lançamento Dr.Cash + Parceria com Banco BV
              </p>
            </div>

            <div className="relative pl-8 border-l-2 border-drcash-caribbean-green">
              <div className="absolute w-4 h-4 bg-drcash-caribbean-green rounded-full -left-[9px] top-0"></div>
              <span className="text-drcash-caribbean-green text-2xl font-bold mb-2 block">2019</span>
              <p className="text-white">
                Rodada de Investimento: Superjobs e FASP + Product Market Fit
              </p>
            </div>

            <div className="relative pl-8 border-l-2 border-drcash-caribbean-green">
              <div className="absolute w-4 h-4 bg-drcash-caribbean-green rounded-full -left-[9px] top-0"></div>
              <span className="text-drcash-caribbean-green text-2xl font-bold mb-2 block">2020</span>
              <p className="text-white">
                Mais de 3.000 clínicas parceiras
              </p>
            </div>

            <div className="relative pl-8 border-l-2 border-drcash-caribbean-green">
              <div className="absolute w-4 h-4 bg-drcash-caribbean-green rounded-full -left-[9px] top-0"></div>
              <span className="text-drcash-caribbean-green text-2xl font-bold mb-2 block">2021</span>
              <p className="text-white">
                Rodada de Investimento: Bossanova e Incubate Fund + Cobertura nacional
              </p>
            </div>

            <div className="relative pl-8 border-l-2 border-drcash-caribbean-green">
              <div className="absolute w-4 h-4 bg-drcash-caribbean-green rounded-full -left-[9px] top-0"></div>
              <span className="text-drcash-caribbean-green text-2xl font-bold mb-2 block">2022</span>
              <p className="text-white">
                R$100 milhões financiados (acumulado) + Rodada de Investimento: Série A com aporte do Banco BV + Valuation de R$175 milhões
              </p>
            </div>

            <div className="relative pl-8 border-l-2 border-drcash-caribbean-green">
              <div className="absolute w-4 h-4 bg-drcash-caribbean-green rounded-full -left-[9px] top-0"></div>
              <span className="text-drcash-caribbean-green text-2xl font-bold mb-2 block">2023</span>
              <p className="text-white">
                Selo Linkedin Top Startups + Parcelex, credor alternativo
              </p>
            </div>

            <div className="relative pl-8">
              <div className="absolute w-4 h-4 bg-drcash-caribbean-green rounded-full -left-[9px] top-0"></div>
              <span className="text-drcash-caribbean-green text-2xl font-bold mb-2 block">2024</span>
              <p className="text-white">
                R$365 milhões financiados (acumulado) + 102 mil vidas beneficiadas (acumulado) + Plug and play + Nova estrutura de credores + Flexibilização de ofertas
              </p>
            </div>
          </div>

          <div className="relative hidden lg:block">
            <div className="sticky top-24">
              <div className="rounded-lg overflow-hidden">
                <img 
                  src="https://drcash.com.br/wp-content/uploads/2023/09/img-story.png" 
                  alt="Dr.Cash História" 
                  className="w-full h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TimelineSection;
